import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

import { page } from '@/store/modules/page';
import { menu } from '@/store/modules/menu';
import { layout } from '@/store/modules/layout';
import { loading } from '@/store/modules/loading';
import { notification } from '@/store/modules/notification';
import { authentication } from '@/store/modules/authentication';
import { version } from '@/store/modules/version';
import { errors } from '@/store/modules/errors';
import { breadcrumbs } from '@/store/modules/breadcrumbs';
import { module } from '@/store/modules/module';
import { dev } from '@/store/modules/dev';
import { privacy } from '@/store/modules/privacy';
import * as statusModal from '@/store/modules/statusModal'
import { deletePropsFromModelByImagePathInCache } from '@/helpers/page';

const vuexPersist = new VuexPersist({
  key: 'i4pro-portal',
  storage: sessionStorage,
  reducer: (state) => {
    const stateToPersist = {};

    // Iterar sobre todos os módulos da store
    Object.keys(state).forEach(moduleName => {
      // Se o módulo for o 'page' e conter na sessionStorage pathFileList, não persistir o state.page.models com o path especificado
      if (moduleName === 'page') {
        stateToPersist[moduleName] = structuredClone(state[moduleName]);

        deletePropsFromModelByImagePathInCache(stateToPersist[moduleName].models);
      } else {
        stateToPersist[moduleName] = { ...state[moduleName] };
      }
    });

    return stateToPersist;
  }
});

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  modules: {
    page,
    menu,
    layout,
    loading,
    notification,
    authentication,
    version,
    errors,
    breadcrumbs,
    module,
    dev,
    privacy,
    statusModal
  }
});
